"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpTopicOptions = exports.statusMFAOptionsMockProps = void 0;
exports.statusMFAOptionsMockProps = {
    title: '',
    field: {
        name: 'mfa',
    },
    options: [
        { value: 'email', label: 'Email', id: 1 },
        { value: 'mobile', label: 'Mobile', id: 2 },
    ],
};
exports.helpTopicOptions = [
    {
        id: 'Account',
        value: 'Account',
        label: 'Account',
        subTopics: [
            {
                id: 'User Account',
                value: 'User Account',
                label: 'I need help with my user account',
            },
            {
                id: 'Login Issues',
                value: 'Login Issues',
                label: "I can't log in to my user account",
            },
            {
                id: 'Verification',
                value: 'Verification',
                label: 'I was not verified as a user',
            },
            {
                id: 'Member Account',
                value: 'Member Account',
                label: 'I need help with my Member account',
            },
        ],
    },
    {
        id: 'Catalog Management',
        value: 'Catalog Management',
        label: 'Catalog Management',
        subTopics: [
            {
                id: 'CWR',
                value: 'CWR',
                label: 'I need help with CWR',
            },
            {
                id: 'Portal Works Registration',
                value: 'Portal Works Registration',
                label: 'I need help registering my work(s) in The MLC Portal',
            },
            {
                id: 'Catalog Transfer',
                value: 'Catalog Transfer',
                label: 'I need help with a catalog transfer',
            },
            {
                id: 'Conflicts and Overclaims',
                value: 'Conflicts and Overclaims',
                label: 'I need help with a conflict or overclaim',
            },
            {
                id: 'Member Relinquishing Claims',
                value: 'Member Relinquishing Claims',
                label: 'I need to relinquish a claim',
            },
            {
                id: 'User Replacement',
                value: 'User Replacement',
                label: 'I need to remove a user from my Member and/or gain access to my Member',
            },
            {
                id: 'DSP Reporting Usage Data Error',
                value: 'DSP Reporting Usage Data Error',
                label: 'I work for a DSP and need to report an error',
            },
            {
                id: 'Editing Works',
                value: 'Editing Works',
                label: 'I need help editing my works',
            },
            {
                id: 'Matching Tool',
                value: 'Matching Tool',
                label: 'I need help with the Matching Tool',
            },
            {
                id: 'Claiming Tool',
                value: 'Claiming Tool',
                label: 'I need help with the Claiming Tool',
            },
        ],
    },
    {
        id: 'Public Search',
        value: 'Public Search',
        label: 'Public Search',
        subTopics: [
            {
                id: 'Public Search',
                value: 'Public Search',
                label: 'I need help with the Public Search',
            },
            {
                id: 'Bulk Database Feed',
                value: 'Bulk Database Feed',
                label: 'I need help with the Bulk Database Feed',
            },
        ],
    },
    {
        id: 'About The MLC',
        value: 'About The MLC',
        label: 'About The MLC',
        subTopics: [
            {
                id: 'General Questions About The MLC',
                value: 'General Questions About The MLC',
                label: 'I have a question about The MLC and its operation',
            },
            {
                id: 'General Works Registration',
                value: 'General Works Registration',
                label: 'Why do I need to register my works with The MLC?',
            },
            {
                id: 'Marketing',
                value: 'Marketing',
                label: 'I have a request for marketing with The MLC',
            },
            {
                id: 'Job Inquiry/Careers',
                value: 'Job Inquiry/Careers',
                label: 'I want to apply for a position with The MLC',
            },
            {
                id: 'User Feedback',
                value: 'User Feedback',
                label: 'I have feedback for The MLC',
            },
        ],
    },
    {
        id: 'Payment',
        value: 'Payment',
        label: 'Payment',
        subTopics: [
            {
                id: 'Payment Setup',
                value: 'Payment Setup',
                label: 'I need help setting up my payment information in The MLC Portal',
            },
            {
                id: 'Royalties Information',
                value: 'Royalties Information',
                label: 'I need information about royalties',
            },
            {
                id: 'Payment Errors',
                value: 'Payment Errors',
                label: 'I need a payment error resolved',
            },
        ],
    },
    {
        id: 'DQI',
        value: 'DQI',
        label: 'DQI',
        subTopics: [
            {
                id: 'DQI',
                value: 'DQI',
                label: 'I need help with DQI',
            },
        ],
    },
];
